/**
 * Acesso tipado às variáveis de ambiente expostas pelo Vite.
 * Só variáveis com prefixo VITE_ chegam até o bundle.
 */
export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:3000/api/v1',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
